import { useEffect } from 'react';
import { useObserver } from 'mobx-react';
import { usePublisherStore } from '.';
import { useEnvStore } from '../env';

function usePublisherInit() {
    const publisherStore = usePublisherStore();
    const env = useEnvStore();

    const signals = useObserver(() => ({
        initialized: env.observed.initialized,
    }));

    useEffect(() => {
        // Wait for initApp() to resolve (getCountryInfo included) so publisher
        // fetches that need location/timezone never race it.
        if (!signals.initialized) return;

        publisherStore.initPublisherData();
    }, [signals.initialized]);
}

export default usePublisherInit;
